import { call, put, select } from 'redux-saga/effects';
import { ScheduleActionType, } from '../../actions/schedule/schedule-actions';
import { createScheduleSuccess, createVNextScheduleSuccess, createScheduleError, } from '../../actions/schedule/schedule-action-creators';
import MlClientError, { FailureOperation } from '../../../data/ml-client-error';
import ScheduleProvider from '../../../data/providers/schedule-provider';
import { default as VNextScheduleProvider } from '../../../data/providers/vnext/arm-api/schedule-provider';
import { ResourceId } from '../../../utils/resource-id';
import { labParentBasedTakeLatest } from '../../effects/lab-parent-based';
import { getLocale, getLanguage } from '../../selectors/common-selectors';
import { getArmAccessTokenSaga } from '../identity/access-tokens';
export function* createSchedule(action) {
    const { schedule, templateId } = action;
    try {
        const resourceId = new ResourceId(templateId);
        const accessToken = yield call(getArmAccessTokenSaga);
        const locale = yield select(getLocale);
        const language = yield select(getLanguage);
        const createdSchedule = yield call(ScheduleProvider.createOrUpdateSchedule, resourceId, accessToken, locale, language, schedule);
        yield put(createScheduleSuccess(createdSchedule));
    }
    catch (e) {
        const error = new MlClientError(e ? e.message : undefined, templateId, FailureOperation.CreateSchedule, e ? e.code : undefined);
        yield put(createScheduleError(error));
    }
}
export function* createVNextSchedule(action) {
    const { schedule, labId } = action;
    try {
        const resourceId = new ResourceId(labId);
        const accessToken = yield call(getArmAccessTokenSaga);
        const locale = yield select(getLocale);
        const language = yield select(getLanguage);
        const createdSchedule = yield call(VNextScheduleProvider.createSchedule, resourceId, accessToken, locale, language, schedule);
        yield put(createVNextScheduleSuccess(createdSchedule));
    }
    catch (e) {
        const error = new MlClientError(e ? e.message : undefined, labId, FailureOperation.CreateSchedule, e ? e.code : undefined);
        yield put(createScheduleError(error));
    }
}
export function* createScheduleSaga() {
    yield labParentBasedTakeLatest(ScheduleActionType.CREATE_SCHEDULE, createSchedule, createVNextSchedule);
}
